// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1vTsN","empty":"ModalGraph_empty__2Dzd0"};